import styled from 'styled-components';

/**
 * Note: When buttonType is buy, pay or plain and the user's payment method is an available card, the payment button displays the card brand and the last four digits of the card number.
 * See https://developers.google.com/pay/api/web/reference/request-objects#ButtonOptions
 */
export var GooglePayButton = styled.div.withConfig({
  componentId: "sc-1tp36kh-0"
})(["width:100%;height:100%;min-width:150px;max-width:750px;display:inline-block;box-sizing:border-box;& > div,& button{min-width:150px !important;}"]);
export var GooglePayButtonContainer = styled.div.withConfig({
  componentId: "sc-1tp36kh-1"
})(["text-align:center;height:100%;"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/GooglePay/styled.js
// module id = 1742
// module chunks = 11